import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const CloudExclamationShape = ({
  width,
  height,
  fillColor = '#EAEAEA',
  secondaryColor = '#FABC3D',
  thirdlyColor = '#FFFFFF',
  style
}: BaseSVGType & { secondaryColor?: string; thirdlyColor?: string }) => {
  return (
    <svg
      height={height}
      width={width}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 512 512"
    >
      <path
        fill={fillColor}
        d="M417.392,161.976h-7.584c-7.536-31.728-36.128-55.504-70.336-55.504c-8.304,0-16.72,1.824-23.68,4.16
	c-16.72-47.488-62.032-81.584-115.44-81.584c-67.616,0-122.448,54.544-122.448,121.84c0,4.24,0.224,8.432,0.64,12.544
	C34.112,171.08,0,209.784,0,256.104c0,51.776,42.576,94.144,94.608,94.144h322.784c52.032,0,94.608-42.368,94.608-94.144
	C512,204.344,469.424,161.976,417.392,161.976z"
      />
      <circle fill={secondaryColor} cx="256" cy="345.496" r="137.456" />
      <path
        fill={thirdlyColor}
        d="M239.616,419.176c0-8.976,6.24-15.456,14.72-15.456c8.976,0,14.704,6.48,14.704,15.456
	c0,8.736-5.728,15.456-14.704,15.456C245.6,434.632,239.616,427.912,239.616,419.176z M245.84,383.544l-3.488-119.648h23.92
	l-3.488,119.648H245.84z"
      />
    </svg>
  );
};

export default CloudExclamationShape;
